import { render, staticRenderFns } from "./InternalAgencyPage.vue?vue&type=template&id=0b461a49&"
import script from "./InternalAgencyPage.vue?vue&type=script&lang=js&"
export * from "./InternalAgencyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports